import { render } from "./ImsiGroupsList.vue?vue&type=template&id=9008bdc6&scoped=true"
import script from "./ImsiGroupsList.vue?vue&type=script&lang=js"
export * from "./ImsiGroupsList.vue?vue&type=script&lang=js"

import "./ImsiGroupsList.vue?vue&type=style&index=0&id=9008bdc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9008bdc6"]])

export default __exports__